(() => {
  'use strict';
  const clean = (value, max = 500) => (value || '').replace(/[\u0000-\u001f]/g, ' ').slice(0, max);
  function updateQuote(link) {
    const url = new URL(link.href, window.location.origin);
    const root = link.closest('.product-information--inner') || link.closest('.product');
    const picker = root && root.querySelector('variant-selects');
    const choices = picker ? [...picker.querySelectorAll('fieldset')].map(field => {
      const input = field.querySelector('input:checked, select');
      return input ? input.value : '';
    }).filter(Boolean) : [];
    let variant;
    if (picker) {
      try {
        const variants = JSON.parse(picker.querySelector('script[type="application/json"]').textContent);
        variant = variants.find(v => v.options.length === choices.length && v.options.every((v, i) => v === choices[i]));
      } catch (_) { /* Keep the selected labels when variant JSON is unavailable. */ }
    }
    url.searchParams.set('product', link.dataset.productTitle);
    url.searchParams.set('product_type', link.dataset.productType);
    const productURL = new URL(link.dataset.productPath, window.location.origin);
    if (variant) productURL.searchParams.set('variant', variant.id);
    url.searchParams.set('product_url', productURL.href);
    if (choices.length) url.searchParams.set('variant', choices.join(' / '));
    else if (url.searchParams.get('variant') === 'Default Title') url.searchParams.delete('variant');
    link.href = url.href;
  }
  function fillContact() {
    const params = new URLSearchParams(window.location.search);
    const set = (id, value) => {
      const field = document.getElementById(id);
      if (field && !field.value && value) field.value = clean(value);
    };
    set('ContactFormProduct', params.get('product'));
    set('ContactFormDocuments', params.get('document_request'));
    const variant = params.get('variant');
    if (variant !== 'Default Title') set('ContactFormVariant', variant);
    const source = params.get('product_url');
    if (source) {
      try {
        const url = new URL(source, window.location.origin);
        if (url.origin === window.location.origin && url.pathname.startsWith('/products/')) set('ContactFormProductURL', url.href);
      } catch (_) { /* Ignore invalid or off-site references. */ }
    }
    const type = clean(params.get('product_type')).toLowerCase();
    let category = '';
    if (type.includes('bagasse')) category = type.includes('cutlery') ? 'Bagasse cutlery' : 'Bagasse tableware';
    else if (type.includes('bamboo')) category = 'Bamboo cutlery';
    else if (type.includes('wood')) category = 'Wooden cutlery';
    else if (type.includes('paper')) category = type.includes('cutlery') ? 'Paper cutlery' : type.includes('plate') ? 'Paper plates' : type.includes('cup') ? 'Paper cups' : 'Paper food packaging';
    set('ContactFormProductCategory', category);
    const extra = document.getElementById('GreenlandExtraRequirements');
    if (extra && (params.get('document_request') || (variant && variant !== 'Default Title') || extra.querySelector('[required]') || document.querySelector('.form-notification.error'))) extra.open = true;
    extra?.addEventListener('invalid', () => { extra.open = true; }, true);
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-greenland-quote]');
    if (link) updateQuote(link);
  }, true);
  document.addEventListener('change', event => {
    const root = event.target.closest('.product-information--inner');
    if (root) root.querySelectorAll('[data-greenland-quote]').forEach(updateQuote);
  });
  document.querySelectorAll('[data-greenland-quote]').forEach(updateQuote);
  fillContact();
  document.addEventListener('shopify:section:load', fillContact);
})();

(() => {
 'use strict';
 document.querySelectorAll('.greenland-spec-scroll').forEach((wrap, index) => {
  const table = wrap.querySelector('table');
  if (!table) return;
  const button = document.createElement('button');
  button.type = 'button'; button.className = 'button outline greenland-spec-download';
  button.textContent = 'Download specifications (CSV)';
  button.addEventListener('click', () => {
   const cell = value => '"' + (/^[=+@-]/.test(value) ? "'" + value : value).replace(/"/g, '""') + '"';
   const rows = [...table.rows].map(row => [...row.cells].map(c => cell(c.textContent.trim())).join(','));
   const name = document.querySelector('h1')?.textContent.trim() || 'Product specifications';
   const csv = '\uFEFF' + [cell(name),cell(table.caption?.textContent.trim() || 'Model specifications'),...rows,cell('Nominal specifications. Confirm model, supply location and final packing with your quotation.'),cell(window.location.origin + window.location.pathname)].join('\r\n');
   const url = URL.createObjectURL(new Blob([csv], {type:'text/csv;charset=utf-8;'}));
   const a = document.createElement('a'); a.href = url;
   a.download = window.location.pathname.split('/').pop() + '-specifications' + (index ? '-' + index : '') + '.csv';
   document.body.append(a); a.click(); a.remove(); setTimeout(() => URL.revokeObjectURL(url),1000);
  });
  wrap.after(button);
 });
})();
